/* eslint no-sequences: "off" */

Math.fround = Math.fround || (function (array) {
    return function(x) {
        return array[0] = x, array[0];
    };
})(new Float32Array(1));

export default {
    toPercent(value, decimals, symbol){
        return (value * 100).toFixed(decimals || 0) + (symbol === '' ? '' : (symbol || '%')); 
    }
}